import * as yup from 'yup';

export const createValidationSchema = (): yup.AnyObjectSchema => {
  return yup.object({
    name: yup.string().required('common.not_empty'),
  });
};
